import { FieldHtmlNameUtil, Trans } from '@onshape/www-inertia';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import UnifiedSignupStartScreen from '../session-info/UnifiedSignupStartScreen';
import AbstractStartSignupScreen from './AbstractStartSignupScreen';
import type UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';

export default class TrialSignupScreen extends AbstractStartSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-start-trial';

  public override getValidatedComponents(): UnifiedSignupScreenComponent[] {
    this.getField(FieldHtmlNameUtil.email).label = Trans.by('Business Email', 'businessEmail');
    return super.getVisibleComponents();
  }

  public predicate(): boolean {
    return (
      this.sessionInfo.value.startScreen.compareTo(UnifiedSignupStartScreen.trialPlan) &&
      this.sessionInfo.value.emailCheckCode === null
    );
  }
}
